window.currentUserData = require('javascripts/consumer/models/current_user_data').default;
